<div class="gcontainer bwhite">
  <div class="row">
    <div class="col-md-11 no-print">
      <nav aria-label="breadcrumb" class="mt-8">
        <ol class="breadcrumb">
          <li
            class="breadcrumb-item active breadcrumb cursor"
            aria-current="page"
            (click)="reDirectUrl()"
            (keypress)="reDirectUrl()"
            tabindex="0">
            Dashboard
          </li>
          <li class="breadcrumb-item active" aria-current="page">Dispose Samples</li>
        </ol>
      </nav>
    </div>
    <h1 class="no-print">Dispose Samples</h1>
    <div class="print-header">
      <h1 class="print-heading">Dispose Samples - {{ generatedFrom | date: 'MM/dd/yyyy' }} - {{ generatedTo | date: 'MM/dd/yyyy' }}</h1>
      @if (assignedToName) {
        <span class="print-assigned-to">Assigned To: {{ assignedToName }}</span>
      }
    </div>

    <form [formGroup]="filterForm" (ngSubmit)="generate()" class="filter-bar no-print">
      <button mat-stroked-button color="primary" type="button" class="history-button" (click)="openPrintHistory()">
        <mat-icon>history</mat-icon>
        History
      </button>
      <div class="date-range">
        <mat-form-field appearance="outline">
          <mat-date-range-input [rangePicker]="picker">
            <input matStartDate formControlName="startDate" placeholder="Start date" readonly />
            <input matEndDate formControlName="endDate" placeholder="End date" readonly />
          </mat-date-range-input>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
      </div>
      <button mat-raised-button color="primary" type="submit" class="generate-button" [disabled]="filterForm.invalid || isLoading">Generate</button>
      @if (hasGenerated && !isLoading) {
        <span class="result-count">{{ dataSource.data.length }} sample(s)</span>
      }
      @if (hasGenerated && !isLoading && dataSource.data.length > 0) {
        <div class="assigned-to">
          <mat-form-field appearance="outline">
            <mat-select placeholder="Assigned To" [(ngModel)]="assignedToId" [ngModelOptions]="{ standalone: true }">
              <mat-option [value]="null">None</mat-option>
              @for (user of users; track user) {
                <mat-option [value]="user.id">{{ user.givenName }} {{ user.surname }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      }
      @if (hasGenerated && !isLoading && dataSource.data.length > 0) {
        <button mat-raised-button color="primary" type="button" class="print-button" (click)="printResults()">Print</button>
      }
    </form>

    @if (hasGenerated && dataSource.data.length > 0) {
      <div class="table-wrapper">
        <table mat-table [dataSource]="dataSource" class="mat-table">
          <ng-container matColumnDef="received">
            <th mat-header-cell *matHeaderCellDef>Received</th>
            <td mat-cell *matCellDef="let sample">{{ sample.received | date: 'MM/dd/yyyy' }}</td>
          </ng-container>
          <ng-container matColumnDef="companyName">
            <th mat-header-cell *matHeaderCellDef>Company Name</th>
            <td mat-cell *matCellDef="let sample">{{ sample.companyName }}</td>
          </ng-container>
          <ng-container matColumnDef="projectName">
            <th mat-header-cell *matHeaderCellDef>Project Name</th>
            <td mat-cell *matCellDef="let sample">{{ sample.projectName }}</td>
          </ng-container>
          <ng-container matColumnDef="jobNumber">
            <th mat-header-cell *matHeaderCellDef>P/O | Job No</th>
            <td mat-cell *matCellDef="let sample">{{ sample.jobNumber }}</td>
          </ng-container>
          <ng-container matColumnDef="state">
            <th mat-header-cell *matHeaderCellDef>State</th>
            <td mat-cell *matCellDef="let sample" [class.flagged-state]="isFlaggedState(sample.state)">{{ sample.state }}</td>
          </ng-container>
          <ng-container matColumnDef="storage">
            <th mat-header-cell *matHeaderCellDef>Storage</th>
            <td mat-cell *matCellDef="let sample">{{ sample.storage }}</td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>
    }

    @if (hasGenerated && !isLoading && dataSource.data.length === 0) {
      <p class="no-results">
        No native soil samples are due in the selected date range.
      </p>
    }

  </div>
</div>

<ng-template #printHistoryDialog>
  <h2 mat-dialog-title class="mat-h2">
    Print History
    <button mat-icon-button class="close-button" mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </h2>
  <mat-dialog-content>
    @if (isHistoryLoading) {
      <p class="no-results">Loading...</p>
    }
    @if (!isHistoryLoading) {
      @if (printHistory.data.length > 0) {
        <div class="table-wrapper print-history-table">
          <table mat-table [dataSource]="printHistory" class="mat-table">
            <ng-container matColumnDef="printedAt">
              <th mat-header-cell *matHeaderCellDef>Printed At</th>
              <td mat-cell *matCellDef="let entry">{{ entry.printedAt | utcToLocal: 'date' }} {{ entry.printedAt | utcToLocal: 'time' }}</td>
            </ng-container>
            <ng-container matColumnDef="printedBy">
              <th mat-header-cell *matHeaderCellDef>Printed By</th>
              <td mat-cell *matCellDef="let entry">{{ entry.printedBy }}</td>
            </ng-container>
            <ng-container matColumnDef="dateRange">
              <th mat-header-cell *matHeaderCellDef>Date Range</th>
              <td mat-cell *matCellDef="let entry">{{ entry.fromDate | date: 'MM/dd/yyyy' }} - {{ entry.toDate | date: 'MM/dd/yyyy' }}</td>
            </ng-container>
            <ng-container matColumnDef="assignedTo">
              <th mat-header-cell *matHeaderCellDef>Assigned To</th>
              <td mat-cell *matCellDef="let entry">{{ entry.assignedTo }}</td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="printHistoryColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: printHistoryColumns"></tr>
          </table>
        </div>
      } @else {
        <p class="no-results">The report has not been printed yet.</p>
      }
      <ng-template #noPrintHistory>
        <p class="no-results">The report has not been printed yet.</p>
      </ng-template>
    }
  </mat-dialog-content>
</ng-template>
